import React, { useState } from 'react'
import { Button, Row, Col, Tooltip, Select, Popover, Spin } from 'antd'
import { connect } from 'react-redux'

import SelectField from 'components/SelectField'
import { BUTTONS } from 'constants/constants'
import {
    DeleteIco,
    PdfIco,
    SpinnerIco,
    XlsIco
} from '../../../../modules/CustomIcons'

import '../../Transfers/TransfersFooter/index.scss'
import { useTranslation } from 'react-i18next'
// import { setSelectedOption } from 'store/actions/salary'

const TransfersFooter: React.FC<any> = (props) => {
    const {t} = useTranslation()
    const [selectedOption,setSelectedOption] = useState('AZ')
  const [visible, setVisible] = useState(false);

    let footerBtnsFirst = [
        {
            icon: <DeleteIco />,
            title: t("transfers.delete"),
        },
    ]
    let footerBtnsSecond = [
        {
            icon: <PdfIco />,
            title: t("home.downloadOrderPayment"),
            key:'pdf'
        },
        {
            icon: <XlsIco />,
            title: t("transfers.downloadExcel"),
            key:'excel'
        },
    ]

    const selectOptions = ['AZ', 'EN','RU']
  
    const content = (
        <div>
          <p onClick={()=>props.handleGetFileClick(selectedOption)} className={'pdf_text'}>{t("transfers.seperatePDF")}</p>
          <p onClick={()=>props.handleGetFileClickMultiple(selectedOption)} className={'pdf_text'}>{t("transfers.multiplePDF")}</p>
        </div>
      );

    return (
        <>
            <Row>
                <Col span={24}>
                    <div className="flex" style={{ justifyContent: 'space-between' }}>
                     <div className='flex' style={{ justifyContent: 'start', marginBottom:30 }} >
                     <Button
                            size={'large'}
                            style={{ marginLeft: 30, marginRight: 10 }}
                            onClick={props.checkTransfer}
                            loading={props.loadCheck}
                            disabled={props.disabled}
                            className="blue-button refresh_btn btn flex align_center justify_center"
                        >
                            {t("transfers.checkTransfers")}
                        </Button>
                        <Button
                            size={'large'}
                            loading={props.loadCreate}
                            disabled={props.createDisabled}
                            onClick={props.createPayment}
                            className="blue-button refresh_btn btn flex align_center justify_center "
                        >
                            {t("transfers.createInTransfers")}
                        </Button>
                     </div>

                        <div className="transfers-footer_btns mass-transfer_footer flex" style={{marginBottom:30}}>
                            <ul
                                className="flex"
                                // style={{ marginRight: '30px', marginTop: '30px' }}
                            >
                                {footerBtnsFirst.map((item) => {
                                    return (
                                        <li>
                                            <Tooltip className='footer-tooltip' title={item.title}>
                                                <Button disabled={props.disableDelete} onClick={()=>props.handleDelete()} ghost icon={item.icon} />
                                            </Tooltip>
                                        </li>
                                    )
                                })}
                            </ul>

                            <ul
                                className="flex"
                                // style={{ marginRight: '30px', marginTop: '30px' }}
                            >
                                <li>
                                    <div className="pagination-selector" style={{ left: '0px' }}>
                                        <Select
                                            defaultValue={'AZ'}
                                            placeholder="AZ"
                                            onChange={setSelectedOption}
                                            width={64}
                                        >
                                            {selectOptions.map((item) => {
                                                return <option value={item}>{item}</option>
                                            })}
                                        </Select>
                                    </div>
                                </li>
                                {footerBtnsSecond.map((item) => {
                                    return (
                                        <li>
                                            
                      {item.key == 'pdf' ?
                        props.loadingPdf ?
                          <div className='ant-btn exportLoadingdiv'><Spin indicator={<SpinnerIco />} /></div>
                          :
                          (props.selectedRow?.length > 1 ?
                            <Popover
                              // className = "btn-popover"
                              placement="top"
                              content={content}
                              trigger="click"
                              visible={!props.disablePDF ? visible :false}
                              onVisibleChange={() => setVisible(!visible)}
                            >
                              <Tooltip className='footer-tooltip' title={item.title}>
                                <Button
                                  icon={item.icon}
                                  disabled={props.disablePDF}
                                />
                              </Tooltip>
                            </Popover> :
                            <Tooltip className='footer-tooltip' title={item.title}>
                              <Button
                                icon={item.icon}
                                disabled={props.disablePDF}
                                onClick={()=>props.handleGetFileClick(selectedOption)}
                              />
                            </Tooltip>
                          )
                        : <Tooltip className='footer-tooltip' title={item.title}>
                          {
                            props.loadingExcel && item.key !== 'adoc' && item.key !== "swift" ?
                              <div className='ant-btn exportLoadingdiv'><Spin indicator={<SpinnerIco />} /></div>
                              :
                              <Button

                                icon={item.icon}
                                disabled={item.key == 'adoc' ? props.disabledADOC : (item.key == "swift" ? props.disabledSwift : props.disabledXLS)}
                                onClick={()=>item.key == 'adoc' ? props.handleGetAdocFileClick : props.handleGetExcelAdditional(selectedOption)}
                              />
                          }
                        </Tooltip>
                          

                      }
                                        </li>
                                    )
                                })}
                            </ul>
                        </div>
                    </div>
                </Col>
            </Row>
        </>
    )
}
export default connect(null, null)(TransfersFooter)
